module.exports = __webpack_public_path__ + "img/ShareProfile_Mockup.6b4d3a8d.png";